// extracted by mini-css-extract-plugin
export default {"personIdContainer":"PersonPlannerMenu-module__personIdContainer___jYFdy","personIdLabel":"PersonPlannerMenu-module__personIdLabel___UgPNU"};